export const deleteEmptyObjectProperties = (data = {}) => {
    const output = {};
    for (const propName in data) {
        if (typeof data[propName] !== "object" || Object.keys(data[propName]).length > 0)
            output[propName] = data[propName];
    }
    return output;
};
